export default "__VITE_PUBLIC_ASSET__488448f4__"